import _ from "lodash";
import { ll } from "../../framework";
import { alert } from "../../framework/controls";
import { ajax } from "./ajax";

export interface GetAllOptions {
    entity: string;
    companyGuid?: string;
    urlPrefix?: string;
    batchSize?: number;
    select?: string;
    expand?: string;
    filter?: string;
    orderBy?: string;
    headers?: any;
    method?: string;
    dataLimit?: number;
}

// This is a wrapper around our ajax code that will retreive all entities that are within the filter.
// This allows us to not have to use arbitrary 'top' values in our OData.
export function getAll(options: GetAllOptions) {
    options.batchSize = options.batchSize || 10000;
    options.urlPrefix = options.urlPrefix || "";
    options.method = options.method || "";
    var deferred: JQueryDeferred<any[]> = $.Deferred();

    var filter = options.filter
        ? `&$filter=${options.filter}`
        : "";
    var entityStartsQueryString = options.entity && options.entity.contains("?");
    var closingEntitySlash = entityStartsQueryString
        ? ""
        : "/";
    var topFilterStart = entityStartsQueryString
        ? "&"
        : "?";
    var url = `${options.urlPrefix}${options.entity}${closingEntitySlash}${options.method}${topFilterStart}$top=0${filter}`;

    ajax({
        url: url,
        companyGuid: options.companyGuid,
        headers: options.headers,
        type: "GET"
    }).done((doneResponse) => {
        if (options.dataLimit && doneResponse.d.__count > options.dataLimit) {
            alert({
                header: ll("ExportLimitExceeded"),
                message: ll("ExportLimitWarning").format(options.dataLimit),
                type: "warning"
            });
            deferred.reject();
        } else {
            var count = doneResponse.d.__count;
            var promises = [];
            var skip = 0;
            var top = count >= options.batchSize
                ? options.batchSize
                : count;

            while (count > 0) {
                promises.push(getBatch(options, skip, top));
                count -= top;
                skip += top;
                top = count >= options.batchSize
                    ? options.batchSize
                    : count;
            }
            Promise.all(promises).then((responses: any[]) => {
                var results = [];
                _.forEach(responses, (response) => {
                    results.push(...response);
                });
                deferred.resolve(results);
            });
        }
    }).fail((failResponse) => {
        deferred.reject(failResponse);
    });

    return deferred.promise();
}

function getBatch(options: GetAllOptions, skip: number, top: number) {
    var deferred: JQueryDeferred<any[]> = $.Deferred();
    var entityStartsQueryString = options.entity && options.entity.contains("?");
    var closingEntitySlash = entityStartsQueryString
        ? ""
        : "/";
    var skipFilterStart = entityStartsQueryString
        ? "&"
        : "?";
    var select = options.select
        ? `&$select=${options.select}`
        : "";
    var expand = options.expand
        ? `&$expand=${options.expand}`
        : "";
    var filter = options.filter
        ? `&$filter=${options.filter}`
        : "";
    var orderBy = options.orderBy
        ? `&$orderBy=${options.orderBy}`
        : "";
    var url = `${options.urlPrefix}${options.entity}${closingEntitySlash}${options.method}${skipFilterStart}$skip=${skip}&$top=${top}`
        + `${select}${expand}${filter}${orderBy}`;

    ajax({
        url: url,
        companyGuid: options.companyGuid,
        headers: options.headers,
        type: "GET"
    }).done((doneResponse) => {
        var results = doneResponse.d.results;
        deferred.resolve(results);
    }).fail((failResponse) => {
        deferred.reject(failResponse);
    });

    return deferred.promise();
}
